  <template>
  <div id="personal">
    <el-dialog :visible.sync="showWeixin" width="600px" style="border-radius: 6px; overflow: hidden;" center>
        <div slot="title">
          <!-- <div class="rect theme-bg"></div> -->
          <div class="dialog-title ">{{$store.state.userinfo.wechat_name == "" || $store.state.userinfo.wechat_name == null?'绑定微信':'解除绑定微信' }}</div>
        </div>
        <div>
          <div class="weixin-qrcode" style="width:182px;height:182px;margin:5px auto;margin-bottom:10px;position:relative; border:solid 1px #c7c7c7;    padding: 10px;
    box-sizing: border-box;">
            <img :src="qrcodeUrl" v-if="qrcodeUrl != ''">
            <div v-show="refresh_qrcode" style="position:absolute;background:rgba(255,255,255,0.8);width:100%;height:100%;top:0;left:0;text-align:center">
              <div style="width:55px;height:55px;background:#FFF;border-radius:27.5px;line-height:55px;text-align:center;box-shadow:0 0 4px rgba(0,0,0,0.5)" class="xy-middle">
                  <span class="iconfont iconshuaxin" style="font-size:26px;" @click="boundweixin"></span>
              </div>
            </div>
          </div>
              <div style="width: 182px;height: 48px;background: rgb(226, 49, 48);margin:0 auto;display: flex;justify-content: space-between;color: #fff; padding: 10px 15px;box-sizing: border-box;align-items: center;">
              <img style="width:24px;height:24px;" src="/static/img/sm.png"><p style="color:#fff;font-size: 13px;line-height:17px;width:104px">{{qrcodeTips}}</p>
            </div>
          <!-- <div style="width:182px;height:52px;line-height:52px;background:#E23130;color:#fff;margin:0px auto;text-align:center;font-size:13px;"></div> -->
        </div>
    </el-dialog>
    <div class="inner" v-if="type==0">
      <el-row class="title">
        <el-col :span="24">
          <div class="grid-content bg-purple-dark g-title">修改个人信息</div>
        </el-col>
      </el-row>
      <el-form class="form-g" ref="form" :model="form" label-width="100px" style="">
        <el-form-item label="用户名：">
          <span>{{$store.state.userinfo.account}}</span>
        </el-form-item>
        <el-form-item label="昵称：">
          <el-input v-model="form.nickname" :placeholder="$store.state.userinfo.user_name"></el-input>
        </el-form-item>
        <el-form-item label="真实姓名：">
          <el-input v-model="form.name" :placeholder="$store.state.userinfo.realname"></el-input>
        </el-form-item>
        <el-form-item label="绑定手机：">
            <span class="act" @click="change(1)" v-if="$store.state.userinfo.mobile==null">立即绑定</span>
            <span v-if="$store.state.userinfo.mobile!=null" style="margin-right: 10px;">{{tels($store.state.userinfo.mobile)}}</span>
              <span class="act "  @click="change(1)" v-if="$store.state.userinfo.mobile!=null">修改绑定</span>
        </el-form-item>
        <el-form-item label="绑定微信：">
          <span class="act " @click="boundweixin" v-if="$store.state.userinfo.wechat_name==null">立即绑定</span>
          <span  v-if="$store.state.userinfo.wechat_name!=null">{{$store.state.userinfo.wechat_name}}</span>
          <span class="act " @click="delweixin" v-if="$store.state.userinfo.wechat_name!=null" style="margin-left:10px;">取消绑定</span>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" class="theme-bg qd" @click="boundname">确定</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="inner" v-if="type==1">
      <el-row class="title">
        <el-col :span="24">
          <div class="grid-content bg-purple-dark  g-title">绑定手机</div>
        </el-col>
      </el-row>
      <el-form class="form-g" :model="phone" label-width="100px" style="width:400px;margin-top: 50px;">
        <el-form-item label="手机号：">
          <el-input v-model="phone.tel"></el-input>
        </el-form-item>
        <el-form-item label="验证码：">
          <el-input
            class="input-css"
            placeholder="请输入验证码"
            style="font-size: 13px;"
            v-model="phone.code"
          ></el-input>
          <el-button  style=" position:absolute;right:0px; background:none;   border: none;height: 52px;color: #f83132;" :loading="codeLoadingreg" @click="getNvc()" class="loginCode">获取验证码</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" class="theme-bg qd" @click="boundphone">确定</el-button>
        </el-form-item>
      </el-form>
    </div>
    <Nvc 
      ref="nverify" 
      :verify="verifyMethods"
    ></Nvc>
  </div>
</template>
<script>
import Nvc from "@/common/nvc";
export default {
  data() {
    return {
      type:0,
      codeLoadingreg:false,//注册验证码
      phoneCode:'',//验证码id
      showWeixin:false,
      qrcodeUrl:"",
      qrcodeTips:"请用微信扫描二维码",
      refresh_qrcode:false,
      t:"",
      form: {
        nickname:'',
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: ""
      },
      phone:{
        tel:'',
        code:'',
      }
    };
  },
  components: {
    Nvc,
  },
  watch:{
    showWeixin(val){
      if(!val){
        clearInterval(this.t);
      }
    }
  },
   methods:{
    getNvc() {
      var _this=this
      var reg = /^[1][3456789][0-9]{9}$/;
      if(!reg.test(this.phone.tel)){
        this.$alert('手机号码不正确', "提示", {
            confirmButtonText: '确定',
            callback: action => {
              _this.codeLoadingreg = false;
          }
          });
          return false
      }
      if(this.codeLoadingreg==true){
        return
      }
      this.$refs.nverify.startVerify()
    },
     change(type){
       this.type=type
     },
     //获取验证码
     getcode(captchaVerifyParam){
       var _this=this
       return new Promise((resolve, reject) => {
          this.codeLoadingreg=true
          this.$api.post(
            "/message",
            {
              id_example: this.$store.state.id_example,
              phone: this.phone.tel,
              type: 3,
              captchaVerifyParam
            },
            res => {
              if (res.data.code == 100) {
                this.phoneCode = res.data.data;
                //短信发送成功开启倒计时
                this.codeLoadingreg = true;
                var time = 60;
                var dd = setInterval(function() {
                  time--;
                  $(".loginCode").html("倒计时("+time + ")秒");
                  if (time <= 0) {
                    clearInterval(dd);
                    _this.codeLoadingreg = false;
                    $(".loginCode ").html(
                      '<span class=\\"van-button__text\\">重新发送</span>'
                    );
                  }
                }, 1000);
                resolve(true)
              } else {
                resolve(false)
                this.$alert(res.data.message, "提示", {
                confirmButtonText: '确定',
                callback: action => {
                  _this.codeLoadingreg = false;
              }
              });
              }
            }
          );
       })
         
     },
     //绑定手机号
     boundphone(){
       this.$api.get('user/user/setphone',{
         id_example:this.$store.state.id_example,
         token_user:this.$store.state.user_id,
         code:this.phoneCode+"_"+this.phone.code,
         phone:this.phone.tel
       },res=>{
         if(res.data.code==100){
          this.$store.commit('userinfo');
           this.$message({
              message: "绑定成功",
              duration: 1500,
              center: true
            });
            this.$store.commit('userInfo')
            this.type=0
         }else{
           this.$message({
              message: res.data.message,
              duration: 1500,
              center: true
            });
         }
       })
     },
     boundweixin(){
      this.$api.get('user/wechat/bind',{
        id_example:this.$store.state.id_example,
        token_user:this.$store.state.user_id
      },res=>{
        this.showWeixin = true;
        this.qrcodeTips = "请用微信扫描二维码";
        this.refresh_qrcode = false;
        this.qrcodeUrl = "http://"+res.data.data.url;
        var _bind_id = res.data.data.bind_id;
        this.t = setInterval(()=>{
          this.$api.get('user/wechat/checkBind',{
            id_example:this.$store.state.id_example,
            token_user:this.$store.state.user_id,
            bind_id:_bind_id
          },res=>{
            if(res.data.code == 100){
              this.showWeixin = false;
              clearInterval(this.t);
              this.$store.commit('userInfo');
            }
          })
        },1000);
        setTimeout(()=>{
          clearInterval(this.t);
          this.refresh_qrcode = true;
          this.qrcodeTips = "二维码已失效，点击重新获取";
        },600000)
      })
     },
     delweixin(){
        this.$api.post('user/wechat/delwechat',{
          id_example:this.$store.state.id_example,
          token_user:this.$store.state.user_id
        },res=>{
          if(res.data.code==100){
            this.$store.commit('userInfo');
          }else{
            this.$message({
                message: "解绑失败",
                duration:1500,
                center:true
            });
          }
        })
     },
     //修改昵称
     boundname(){
       if(this.form.name!=''&&this.form.nickname==''){
         this.form.nickname=this.$store.state.userinfo.user_name
       }
       this.$api.get('user/user/updatename',{
         id_example:this.$store.state.id_example,
         token_user:this.$store.state.user_id,
         name:this.form.nickname,
         realname:this.form.name
       },res=>{
         if(res.data.code==100){
           this.$message({
              message: '修改成功',
              duration: 1500,
              center: true
            });
           this.$store.commit('userInfo')
         }else{
           this.$message({
              message: res.data.message,
              duration: 1500,
              center: true
            });
         }
       })
     },
     //隐藏手机号
     tels(tel){
       var reg = /^(\d{3})\d{4}(\d{4})$/;
       if(tel!=null){
         tel = tel.replace(reg, "$1****$2");
       }
       return tel
     },
    verifyMethods(captchaVerifyParam) {
      return new Promise(async(resolve, reject) => {
        const data = await this.getcode(captchaVerifyParam)
        resolve(data)
      })
    }
  }
};
</script>
<style lang="less" scoped>
 .v-modal{
  background: rgba(38, 38, 38, 0.8) !important;
  opacity: 1 !important;
}
/deep/ .el-dialog__wrapper{
  border-radius:6px;
  overflow:hidden;
}
/deep/ .el-dialog--center {
  border-radius:6px;
  overflow:hidden;
}
/deep/ .el-dialog--center .el-dialog__body{
  padding-bottom: 70px;

}
/deep/ .el-dialog__header {
    border-bottom: 1px solid #f5f5f5;
    background: #f5f5f5;
    padding: 10px 20px 10px !important;
}
/deep/ .el-form-item__label{
  width: 70px !important;
  padding: 0px !important;
  color: #272727 !important;
}
/deep/ .el-dialog__header .dialog-title{
  margin-top: 0px !important;
  height: 40px  !important;
font-size: 24px  !important;
font-family: MicrosoftYaHei  !important;
color: #262626  !important;
line-height: 40px  !important;

 }
 /deep/.el-form-item{
   margin-bottom: 15px;
 }
 /deep/.el-input__inner{
   height: 52px;
background: #FAFAFA;
border: 1px solid #D6DEE9;
color:#262626;
        &:hover{
        border:solid 1px #b8bfc9;
      }
 }
.qd{
 width: 100% !important;
height: 48px !important;
background: #E23130;
border-radius: 6px;
border: 1px solid #E23130;
transition: all 0.5s !important;
}
.qd{
  border: 1px solid #E23130 !important;
}
 .g-title{
    height: 40px;
font-size: 24px;
font-family: MicrosoftYaHei;
color: #262626;
line-height: 40px;
border-bottom: dashed 1px rgba(151,151,151,0.5);
padding-bottom: 8px;
  }

#personal {
  width: 985px;
min-height: 572px;
  float: left;
  background: #fff;
  box-shadow: 0px 9px 13px 0px rgba(190, 190, 190, 0.2);
  .inner {
    box-sizing: border-box;
    padding: 10px 30px;
     .form-g{
    padding:0px 284px;
    margin-top: 50px;
  }
    .inputbox {
      // margin: 40px;

      input {
 width: 240px;
      height: 38px;
      border: 1px solid rgba(230, 231, 231, 1);
      padding: 0 15px;
      box-sizing: border-box;
        &:hover{
        border:solid 1px #b8bfc9;
      }
      &:focus,&:active{
         border:solid 1px #E23130!important;
      }
      }
    }
    button {
      width: 109px;
      height: 36px;
      text-align: center;
    }
    .act{
        color: #4478D6;

    }
  }
  .handleNav {
    height: 40px;
    background: #e3e3e3;
    border: 1px solid #ddd;
    margin-top: 55px;
    span {
      display: inline-block;
      height: 40px;
      line-height: 40px;
      text-align: center;
    }
    .name1 {
      width: 370px;
      margin-left: 20px;
      text-align: left;
    }
    .name2 {
      width: 240px;
    }
    .name3 {
      width: 270px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/user/cont/personal.vue